module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fYHaEI/media/FC-9798889102731.jpg?1708992365158",
      "alt": "This image is the cover for the book Kill Two Birds with One Stone"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kill Two Birds with One Stone\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("Homeless and ashamed, a young women named Arabelle struggles to survive. When she ")]), _c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("seeks")]), _c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v(" to escape her reality with friends in a forest, an accident occurs causing the forest to erupt in flames. While everyone makes it out")]), _c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v(" alive")]), _c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v(", the blame falsely falls on one friend, leaving Arabelle with immense guilt for hiding the truth.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("She finds herself with an ultimatum that will change the course of her life. Blocking out his past, a firefighter named Tucker immerses himself in his work and hobbies. He crosses paths with Arabelle")]), _c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v(" during the")]), _c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v(" forest fire and they begin to form a friendship. ")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Bierstadt\",sans-serif"
    }
  }, [_vm._v("Though their relationship blossoms, Arabelle fears her secrets and past will push Tucker away. Meanwhile, Tucker fears his feelings for Arabelle will leave him with a broken heart because of a past friendship he’d lost.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ava Mae\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Ava Mae is a newly graduated student with her bachelor’s in social work; however, her passion lies in writing. She believes books are the bridge to the imagination and can take one across the world without leaving the comfort of their chair. She enjoys outdoor activities and nature. Most of all, she enjoys educating herself on the individual lives of others and their experiences.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0